import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import BaseApiProvider from "./BaseApiProvider"
import Logger from 'utilities/log';

class AxiosApiProvider implements BaseApiProvider {
    private static instance: AxiosApiProvider | null = null;
    private axiosInstance: AxiosInstance;
    private baseUrl: string;
    private token?: string;
    private config?: AxiosRequestConfig;

    public constructor(baseUrl: string, token?: string, config?: AxiosRequestConfig) {
        this.baseUrl = baseUrl;
        this.token = token;
        this.config = config;
        this.axiosInstance = axios.create({
            baseURL: baseUrl,
            timeout: 50000,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token ? `${token}` : '',
            }
        });
    }

    // public static getInstance(baseUrl: string, token?: string): AxiosApiProvider {
    //     if (!AxiosApiProvider.instance) {
    //         AxiosApiProvider.instance = new AxiosApiProvider(baseUrl, token);
    //     }
    //     return AxiosApiProvider.instance;
    // }

    public async get(path: string, config?: AxiosRequestConfig): Promise<any> {
        try {
            const response: AxiosResponse = await this.axiosInstance.get(path, config);
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform GET request:', error);
            throw new Error(`Failed to perform GET request: ${error}`);
        }
    }

    public async post(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        try {
            const response: AxiosResponse = await this.axiosInstance.post(path, data, config);
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform POST request:', error);
            throw new Error(`Failed to perform POST request: ${error}`);
        }
    }

    public async postForm(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        try {
            const headers = {
                ...config?.headers,
            };
            const response: AxiosResponse = await this.axiosInstance.postForm(path, data, {
                ...config,
                headers
            });

            return response.data;
        } catch (error) {
            Logger.error('Failed to perform POST request:', error);
            throw new Error(`Failed to perform POST request: ${error}`);
        }
    }

    public async postFormData(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        
        try {
    
         
            const headers ={
                'Content-Type': 'multipart/form-data;',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.token ? `${this.token}` : '',
            }
            const response: AxiosResponse = await this.axiosInstance.postForm(path, null, {
                headers,
                withCredentials: true, 
                  params: data
            }
            );
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform POST request:', error);
            throw new Error(`Failed to perform POST request: ${error}`);
        }
    }

    public async getForm(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        try {
            // Convert data object to query string
            const params = new URLSearchParams(data).toString();
            const url = params ? `${path}?${params}` : path;

            const response: AxiosResponse = await this.axiosInstance.get(url, config);
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform GET request:', error);
            throw new Error(`Failed to perform GET request: ${error}`);
        }
    }
    public async getForm2(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        try {
            //http://192.168.15.13:9091/Users/Login
            //http://91.92.186.105:9091/Users/Login
            // Convert data object to query string
            //const params = new URLSearchParams(data).toString();
            //const url = params ? `${path}?${params}` : path;
            const response: AxiosResponse = await this.axiosInstance.request({
                method: 'GET',
                url: path,
                data: data, // Setting formData in the request body
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...config?.headers
                },
                ...config
            });
            //const response: AxiosResponse = await this.axiosInstance.get(url, config);
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform GET request:', error);
            throw new Error(`Failed to perform GET request: ${error}`);
        }
    }

    public async patch(path: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        try {
            const response: AxiosResponse = await this.axiosInstance.patch(path, data, config);
            return response.data;
        } catch (error) {
            Logger.error('Failed to perform PATCH request:', error);
            throw new Error(`Failed to perform PATCH request: ${error}`);
        }
    }
}

export default AxiosApiProvider;
